/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_step0_description = /** @type {(inputs: {}) => string} */ () => {
	return `Elige la opción que mejor se adapte a ti. Siempre podrás cambiarla después.`
};

const en_onboarding_step0_description = /** @type {(inputs: {}) => string} */ () => {
	return `Choose the option that best fits your needs. You can always change it later.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_step0_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_step0_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_step0_description", locale)
	if (locale === "es") return es_onboarding_step0_description(inputs)
	return en_onboarding_step0_description(inputs)
};
export { onboarding_step0_description as "onboarding.step0.description" }